import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * QR-Code als SVG -- scharf in jeder Groesse, im 1280er-Ausgang wie am
 * Beamer. Fehlerkorrektur „M": genug Reserve fuer ein unscharfes Handyfoto
 * vom Bildschirm, ohne dass der Code unnoetig dicht wird.
 *
 * Kodiert wird die Adresse, wie der Browser sie schreibt (`URL.href`):
 * Umlaute im Pfad als %-Folge, im Namen als Punycode -- so liest jede
 * Kamera-App dieselbe Adresse.
 */
export function QrCode({ value, className }: { value: string; className?: string }) {
  const code = useMemo(() => {
    let text = value;
    try {
      text = new URL(value).href;
    } catch {
      /* Dann eben so, wie es ist. */
    }
    try {
      const qr = qrcode(0, 'M');
      qr.addData(text);
      qr.make();
      const n = qr.getModuleCount();
      let d = '';
      for (let row = 0; row < n; row++) {
        for (let col = 0; col < n; col++) if (qr.isDark(row, col)) d += `M${col} ${row}h1v1h-1z`;
      }
      return { n, d };
    } catch {
      return null;
    }
  }, [value]);

  if (!code) return null;
  return (
    <svg className={className} viewBox={`0 0 ${code.n} ${code.n}`} shapeRendering="crispEdges" aria-hidden>
      <path d={code.d} fill="currentColor" />
    </svg>
  );
}
